// This code copes with the fact that both the client and the server represent dates
// as times at midnight, but potentially in different time zones.
//
// We send dates as-is from the client to server, which, if it's in a different time
// zone, will see them as times not at midnight, possibly on a day earlier or later.
// The server then truncates the time to midnight on that day, which allows dates to
// be comparable independent of time.
//
// When the client receives such a date from the server, we effectively undo the
// server's time truncation, converting the date back to midnight in the client's
// time zone.

import { Context } from "csi/def/Context";

// Number: client offset from UTC in milliseconds
const _clientOffset: number = -(new Date()).getTimezoneOffset() * 60 * 1000;

export = {
	getServerOffset(ctx: Context): number {
		let node = ctx.getNode();

		while (node && (node.TimeZoneOffsetMillis === undefined)) {
			node = ctx.getNodeParent(node, true);
		}

		return node ? node.TimeZoneOffsetMillis : 0;
	},

	clientToServer(clientTime: number, serverOffset: number): number {
		return this._clientToServer(clientTime, serverOffset, _clientOffset);
	},

	serverToClient(serverTime: number, serverOffset: number): number {
		return this._serverToClient(serverTime, serverOffset, _clientOffset);
	},

	_serverToClient(serverTime: number, serverOffset: number, clientOffset: number): number {
		if (!(serverTime && serverOffset) || serverOffset === clientOffset) {
			return serverTime;
		}

		const offset = serverOffset - clientOffset;
		return serverTime + offset;
	},

	_clientToServer(clientTime: number, serverOffset: number, clientOffset: number): number {
		if (!(clientTime && serverOffset) || serverOffset === clientOffset) {
			return clientTime;
		}

		const offset = serverOffset - clientOffset;
		return clientTime - offset;
	},
};
